export const voeding = [
  "Pizza",
  "Hamburger",
  "Pasta",
  "Sushi",
  "Salade",
  "Brood",
  "Kaas",
  "Wijn",
  "Bier",
  "Koffie",
  "Thee",
  "Frisdrank",
  "Pannenkoeken",
  "Wafels",
  "Chocolade",
  "IJs",
  "Yoghurt",
  "Fruitsalade",
  "Milkshake",
  "Smoothie",
  "Pindakaas",
  "Honing",
  "Ketchup",
  "Mayonaise",
  "Olijfolie",
  "Boter",
  "Suiker",
  "Zout",
  "Peper",
  "Kruiden",
  "Specerijen",
  "Rijst",
  "Noedels",
  "Kip",
  "Rundvlees",
  "Varkensvlees",
  "Vis",
  "Garnalen",
  "Zalm",
  "Tonijn",
  "Ei",
  "Bacon",
  "Ham",
  "Kalkoen",
  "Lamsvlees",
  "Gehakt",
  "Worst",
  "Friet",
  "Gebakken aardappelen",
  "Groenten",
  "Fruit",
  "Tomaten",
  "Komkommer",
  "Wortelen",
  "Paprika",
  "Ui",
  "Knoflook",
  "Aardappelen",
  "Maïs",
  "Erwten",
  "Bonen",
  "Avocado",
  "Appel",
  "Banaan",
  "Sinaasappel",
  "Citroen",
  "Aardbei",
  "Meloen",
  "Ananas",
  "Mango",
  "Druiven",
  "Noten",
  "Amandelen",
  "Walnoten",
  "Cashewnoten",
  "Pinda's",
  "Chips",
  "Popcorn",
  "Snoep",
  "Koekjes",
  "Taart",
  "Cake",
  "Brownies",
  "Donuts",
  "Croissant",
  "Bagel",
  "Boterham",
  "Hotdog",
  "Burrito",
  "Taco",
  "Nacho's",
  "Gyoza",
  "Ramen",
  "Curry",
  "Stoofpot",
  "Soep",
  "Lasagne",
  "Quiche",
  "Saus",
  "Gebakken rijst",
  "Gebakken noedels",
  "Paella",
  "Goulash",
  "Spareribs",
  "Kebab",
  "Gyros",
  "Saté",
  "Steak",
  "Roerbakgerecht",
  "Barbecue",
  "Fondue",
  "Hummus",
  "Guacamole",
  "Tzatziki",
  "Pesto",
  "Salsa",
  "Sushi-rol",
  "Tempura",
  "Springroll",
  "Gazpacho",
  "Griekse salade",
  "Caesarsalade",
  "Nicoise salade",
  "Couscous",
  "Tabouleh",
  "Guinness",
  "Heineken",
  "Corona",
  "Coca-Cola",
  "Pepsi",
  "Sprite",
  "Fanta",
  "Red Bull",
  "Monster Energy",
  "Limonade",
  "Ice tea",
  "Margarita",
  "Mojito",
  "Cosmopolitan",
  "Piña colada",
  "Martini",
  "Bloody Mary",
  "Mimosa",
  "Champagne",
  "Whisky",
  "Wodka",
  "Rum",
  "Gin",
  "Tequila",
  "Brandy",
  "Cognac",
  "Sake",
  "Limoncello",
  "Espresso",
  "Cappuccino",
  "Latte",
  "Macchiato",
  "Matcha",
  "Chai",
  "Earl Grey",
  "Groene thee",
  "Kamillethee",
  "Pepermuntthee",
  "Rooibosthee",
  "Kruidenthee",
  "Water",
  "Melk",
  "Jus d'orange",
  "Appelsap",
  "Cola",
  "Limonade",
  "Ijsthee",
  "Bakvorm",
  "Pan",
  "Koekenpan",
  "Oven",
  "Mixer",
  "Blender",
  "Keukenmes",
  "Snijplank",
  "Maatbeker",
  "Weegschaal",
  "Garde",
  "Zeef",
  "Klopper",
  "Bakpapier",
  "Ovenschaal",
  "Bakkwast",
  "Kookpan",
  "Steelpan",
  "Koelkast",
  "Vriezer",
  "Magnetron",
  "Broodrooster",
  "Blender",
  "Koffiezetapparaat",
  "Waterkoker",
  "Citruspers",
  "Messenblok",
  "Pannenset",
  "Schaal",
  "Borden",
  "Bestek",
  "Glazen",
  "Mokken",
  "Servetten",
  "Broodrooster",
  "Grillpan",
  "Rijstkoker",
  "Stoommandje",
  "Slowcooker",
  "Barbecue",
  "Kruidenrek",
  "Pepermolen",
  "Zoutvaatje",
  "Maatlepels",
  "Maatbekers",
  "Bakvormen",
  "Mixkom",
  "Deegroller",
  "Baksteen",
  "IJsschep",
  "Snijplank",
  "Keukenweegschaal",
  "Afvalemmer",
  "Afwasborstel",
  "Afwasmiddel",
  "Theedoeken",
  "Ovenwanten",
  "Pannenlappen",
  "Schort",
  "Vergiet",
  "Spatel",
  "Pollepel",
  "Serveertang",
  "Blikopener",
  "Flessenopener",
  "Kurkentrekker",
  "Keukentang",
  "Citruspers",
  "Knoflookpers",
  "Kaasschaaf",
  "Eiersnijder",
  "Pizzasnijder",
  "Groenteschiller",
  "Kookwekker",
  "Theezeef",
  "Bakpapier",
];
